<article class="card" [style.--accent-color]="getAccentColor()">
  <div class="card-header">
    <h3 class="card-title">{{ title() }}</h3>
    @if (status()) {
      <span
        class="card-status"
        [ngStyle]="getStatusStyle()"
        [class]="getStatusClass()"
      >
        {{ status() }}
      </span>
    }
  </div>

  @if (description()) {
    <p class="card-description">{{ description() }}</p>
  }

  @if (items().length) {
    <div class="card-meta">
      @for (item of items(); track trackByIndex($index)) {
        <div class="card-meta-item" [class.card-meta-item--full]="item.row === 3" [class.card-meta-item--wrap]="item.row === 3">
          @if (item.icon) {
            <mat-icon>{{ item.icon }}</mat-icon>
          }
          <div class="card-meta-item-content">
            <span class="card-meta-label">{{ item.label }}</span>
            @if (item.value) {
              <span class="card-meta-value">{{ item.value }}</span>
            }
          </div>
        </div>
      }
    </div>
  }

  @if (actions().length) {
    <div class="card-actions">
      @for (action of actions(); track trackByIndex($index)) {
        <button
          class="card-action-btn"
          [class.card-action-btn--primary]="action.color === 'primary'"
          [class.card-action-btn--danger]="action.color === 'danger'"
          [matTooltip]="action.label"
          matTooltipPosition="above"
          (click)="action.action()"
        >
          <mat-icon>{{ action.icon }}</mat-icon>
        </button>
      }
    </div>
  }

  <ng-content select="[card-footer]"></ng-content>
</article>
